import React, { Component } from 'react'
import { Link } from 'react-router'

import './styles/ViewLoginStyles.css'

class ViewLogin extends Component {

    showError() {
        console.log('error')
    }

    render() {

        if (this.props.error) {
            setTimeout(()=>{
                this.props.clearForm()
            },900)
        }

        return (
            <div className={'ViewLoginWrapper'}>
                <div className={`ViewLoginFormWrapper ${this.props.error?'shake':''}`}>
                    <div className={'ViewLoginFormWrapperHeader'}>
                        <span className={'ViewLoginFormTitle'}>{'Административная панель'}</span>
                    </div>
                    <div className={'ViewLoginFormWrapperContent'}>
                        <div className="formRow">
                            <label htmlFor="LoginInput">E-mail</label>
                            <input
                                value={this.props.login}
                                id={'LoginInput'}
                                ref={'LoginInput'}
                                type="text"
                                onChange={(e) => {
                                    this.props.performInputLogin(this.refs.LoginInput.value)
                                }}
                            />
                        </div>
                        <div className="formRow">
                            <label htmlFor="LoginInput">Пароль</label>
                            <input
                                value={this.props.password}
                                id={'PasswordInput'}
                                ref={'PasswordInput'}
                                type="password"
                                onChange={(e) => {
                                    this.props.performInputPassword(this.refs.PasswordInput.value)
                                }}
                            />
                        </div>
                        <div className="formRow">
                            <button onClick={this.props.performLogin}>Войти</button>
                        </div>
                        <div className="formRow">
                        <Link to={`/`} className={'FormLink'} activeClassName="active">{'На главную'}</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ViewLogin


// WEBPACK FOOTER //
// ./src/Components/ViewLogin.js